import React, { useState } from "react";
import { Button, Input, Flex } from "antd";
import "../auth-common.css";
import "../set_password/set_password.css";
import { useNavigate, useParams } from "react-router-dom";
import SisLoader from "../../widgets/loader";
import { ErrorToast, SuccessToast } from "../../widgets/AppToast";
import { post } from "../../services/services";
import { ApiURL } from "../../services/apiConstants";

const OtpVerification = () => {
  const navigate = useNavigate();
  const { email, otp_type } = useParams();
  const [loader, setLoader] = useState(false);
  const [errors, setErrors] = useState({});
  const [otpValue, setOtpValue] = useState("");

  const verifyOtp = async () => {
    setLoader(true);
    const formData = new FormData();
    formData.append("otp_value", otpValue);
    formData.append("email", atob(email));
    formData.append("otp_type", atob(otp_type));
    try {
      const res = await post(ApiURL.registration_otp_verification, formData);
      if (res?.status === true) {
        SuccessToast("Success", "Otp verified successfully");
        if (atob(otp_type) === "forgot_password") {
          navigate("/set-new-password/" + res?.token + "/" + email);
        } else {
          navigate("/");
        }
      } else {
        ErrorToast("Error", "Otp invalid. Please try again");
      }
    } catch (error) {
      setErrors({
        ...errors,
        api: "An error occurred during OTP verification. Please try again.",
      });
    } finally {
      setLoader(false);
    }
  };

  const resendOtp = async () => {
    setLoader(true);
    const formData = new FormData();
    formData.append("otp_type", atob(otp_type));
    formData.append("email", atob(email));
    try {
      const res = await post(ApiURL.resent_otp, formData);
      if (res?.status === true) {
        SuccessToast("Success", res?.message);
      } else {
        setErrors({ ...errors, api: res?.message });
      }
    } catch (error) {
      setErrors({
        ...errors,
        api: "An error occurred during OTP resend. Please try again.",
      });
    } finally {
      setLoader(false);
    }
  };

  return loader ? (
    <SisLoader />
  ) : (
    <div className="auth-page-container">
      <div className="auth-glass-card">
        <div className="auth-header">
          <h5>MarinBytes - Data, Ships, People and Sustainability</h5>
          <h2>OTP Verification</h2>
        </div>
        <div className="auth-body">
          {errors?.api && <span style={{ color: "red", display: 'block', marginBottom: '10px' }}>{errors.api}</span>}
          <div className="auth-input-group">
            <label style={{ textAlign: "center" }}>Verification Code</label>
            <Flex justify="center">
              <Input.OTP
                size="large"
                length={4}
                onChange={setOtpValue}
                value={otpValue}
              />
            </Flex>
          </div>
          <div style={{ textAlign: "center", marginBottom: '20px' }}>
            <span
              className="auth-link-btn"
              style={{ fontSize: "14px" }}
              onClick={resendOtp}
            >
              Didn't get the code? Resend OTP
            </span>
          </div>
          <Button 
            loading={loader} 
            className="auth-primary-btn" 
            type="primary" 
            onClick={verifyOtp}
          >
            Verify & Proceed
          </Button>
        </div>
      </div>
    </div>
  );
};

export default OtpVerification;
